// ModalPortal — renders its children into <body> via a portal so overlays escape
// any ancestor that would otherwise become their containing block (e.g. the
// island-layout content card with its margins/rounding). Without this, a
// `fixed inset-0` modal anchors to the card and shows a gap at the top.
// Wrap any hand-rolled modal/slide-over's root element in <ModalPortal>.
import React from 'react';
import { createPortal } from 'react-dom';

export const ModalPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    if (typeof document === 'undefined') return null;
    return createPortal(children, document.body);
};

export default ModalPortal;
